import { IModel } from "@/@types/models/model";
import { buttonFields } from "@/models/helpers/buttonFields";
import { commonFields } from "./helpers/commonFields";
import { coreFields } from "./helpers/coreFields";

const Objekti: IModel = {
  title: "Objekti",
  source: "objekti",
  apiPath: "objekti/",
  forms : {
    "default": {
      fields: ["id", "sifra", "opis"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "sifra", "opis"],
      hidden: []
    },
    "tooltip": {
      fields: ["id", "sifra", "opis"],
    },
    "attribute_table": {
      fields: ["id", "sifra", "opis"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Šifra",
      source: "sifra",
      ttoken: "common.sifra",
      type: "text",
      readonly: true
    },
    {
      title: "Opis",
      source: "opis",
      ttoken: "common.opis",
      type: "text",
      readonly: true
    },
    {
      title: "Namjena",
      source: "namjena",
      ttoken: "objekti.namjena",
      type: "text",
      readonly: true
    },
    {
      title: "visina",
      source: "visina",
      ttoken: "objekti.visina",
      type: "numeric",
      readonly: true
    },
    {
      title: "napomena",
      source: "napomena",
      ttoken: "common.napomena",
      type: "text",
      readonly: true
    },
    {
      title: "grijano",
      source: "grijano",
      ttoken: "objekti.grijano",
      type: "text",
      readonly: true
    },
    commonFields.wkt,
    buttonFields.deselect
  ]
}

export default Objekti;
